export const TIMEZONE = 'America/New_York';

export const NO_TRADING = 'NO_TRADING';
export const PRE_MARKET = 'PRE_MARKET';
export const REGULAR = 'REGULAR';
export const AFTER_MARKET = 'AFTER_MARKET';

export const FETCHING = 'FETCHING';
export const FETCHED = 'FETCHED';
export const ERRORED = 'ERRORED';

export const CHANGE = 'change';
export const CHANGE_PERCENT = 'changePercent';

export const DAY = 'day';
export const MONTH = 'month';
export const YEAR = 'year';

export const UPGRADES = 'Upgrades';
export const DOWNGRADES = 'Downgrades';

export const BUY = 'Buy';
export const CONVICTION_BUY = 'Conviction Buy';
export const OVERWEIGHT = 'Overweight';
export const STRONG_BUY = 'Strong Buy';
export const OUTPERFORM = 'Outperform';
export const MARKET_OUTPERFORM = 'Market Outperform';

export const SELL = 'Sell';
export const UNDERWEIGHT = 'Underweight';
export const UNDERPERFORM = 'Underperform';

export const ANNOUNCES = 'Announces';

export const RANGES = {
  // 365 = (365 / 5) * 5
  '10y': { from: '10y', interval: '10d', refreshRate: 360000 },

  /* eslint-disable sort-keys */
  '1d': { from: '1d', interval: '2m', refreshRate: 15000 },

  // 360 = (24 * (60 / 20)) * 5
  '1m': { from: '1m', interval: '1h', refreshRate: 90000 },

  // 365
  '1y': { from: '1y', interval: '1d', refreshRate: 360000 },

  // 365
  '2y': { from: '2y', interval: '2d', refreshRate: 360000 },

  // 372 = (24 /2) * 31
  '3m': { from: '3m', interval: '6h', refreshRate: 360000 },

  '5d': { from: '5d', interval: '10m', refreshRate: 30000 },

  // 365 = (365 / 2) * 2
  '5y': { from: '5y', interval: '5d', refreshRate: 360000 },

  // 372 = (24 / 6) * (31 * 3)
  '6m': { from: '6m', interval: '1d', refreshRate: 360000 },

  // 365 = (365 / 10) * 10
  Max: { from: '1980-01-01', interval: '1mo', refreshRate: 360000 },
  // 372 = (24 / 12) * (31 * 3)
  YTD: { from: 'YTD', interval: '1d', refreshRate: 360000 }, // 1274 = (52 / 2) * 49
  /* eslint-enable sort-keys */
};

export const MAX_RANGES = {
  '10y': 'Max',
  '1d': '2y',
  '1m': '2y',
  '1y': '10y',
  '2y': '10y',
  '3m': '2y',
  '5d': '2y',
  '5y': 'Max',
  '6m': '2y',
  Max: 'Max',
  YTD: '10y',
};

export enum Routes {
  home = '/',
  movers = '/movers',
}

export const blueThemeColor = 'rgb(44, 162, 209)';
